import { render, staticRenderFns } from "./ListSales.vue?vue&type=template&id=597d114b&scoped=true&"
import script from "./ListSales.vue?vue&type=script&lang=js&"
export * from "./ListSales.vue?vue&type=script&lang=js&"
import style0 from "./ListSales.vue?vue&type=style&index=0&id=597d114b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597d114b",
  null
  
)

export default component.exports